// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const ShareFileWarningDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-sharefilewarningdialogcontainer" */ "./ShareFileWarningDialogContainer")).then((bundle)=>{
        return {
            default: bundle.ShareFileWarningDialogContainer
        };
    });
export const LazyShareFileWarningDialogContainer = /*#__PURE__*/ lazy(ShareFileWarningDialogContainerLazyLoader);
